import { render, staticRenderFns } from "./enterpriseNews.vue?vue&type=template&id=6b69d044&"
import script from "./enterpriseNews.vue?vue&type=script&lang=js&"
export * from "./enterpriseNews.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports